import React from 'react';
import { WysiwygField as DefaultWysiwygField, TableRender } from '@uncinc/uncinc-react-kitchen-sink';
import { convertNodeToElement } from 'react-html-parser';

export const customElementHandler = (node) => {
  switch (node.name) {
    case 'table': {
      return (
        <TableRender element={convertNodeToElement(node)} {...node.attribs} />
      );
    }
    default: {
      return null;
    }
  }
};

const WysiwygField = (props) => {
  return (
    <DefaultWysiwygField
      customElementHandler={customElementHandler}
      {...props}
    />
  );
};

export default WysiwygField;
